import * as THREE from 'three'
import { gsap, Power3 } from 'gsap';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import Experience from "./Experience";

export default class Camera {

    constructor() {

        // console.log('my camera');
        this.experience = new Experience()
        this.sizes = this.experience.sizes
        this.scene = this.experience.scene
        this.canvas = this.experience.canvas
        this.debug = this.experience.debug
        this.initialPosition
        this.initialRotation
        this.rotationCounter = 0

        this.setIstance()
        this.setOrbitControls()

        if (this.debug.active) {

            this.debugFolder = this.debug.ui.addFolder('Camera')

            this.setGui()
        }

        let zoomIn = -2.5
        let zoomOut = -8

        if (this.isMobileDevice()) {
            zoomOut = -10

        }

        document.getElementById('rotate').addEventListener('click', () => this.rotateCameraRight(this.istance, this.scene.children[1], this.controls))
        document.getElementById('reset-button').addEventListener('click', () => this.resetRotation(this.istance, this.controls))
        document.getElementById('zoom-in').addEventListener('click', () => this.cameraZoomInOut(this.istance, this.scene.children[1], zoomIn, this.controls))
        document.getElementById('zoom-out').addEventListener('click', () => this.cameraZoomInOut(this.istance, this.scene.children[1], zoomOut, this.controls))
        document.getElementById('mobile-rotate').addEventListener('click', () => this.rotateCameraRight(this.istance, this.scene.children[1], this.controls))
        document.getElementById('mobile-reset-button').addEventListener('click', () => this.resetRotation(this.istance, this.controls))
        document.getElementById('mobile-zoom-in').addEventListener('click', () => this.cameraZoomInOut(this.istance, this.scene.children[1], zoomIn, this.controls))
        document.getElementById('mobile-zoom-out').addEventListener('click', () => this.cameraZoomInOut(this.istance, this.scene.children[1], zoomOut, this.controls))

    }

    setIstance() {
        this.istance = new THREE.PerspectiveCamera(35, this.sizes.width / this.sizes.height, 0.1, 25)
        // this.istance.position.set(6, 5, 7)
        // this.istance.position.set(7, 6, 1)
        // this.istance.position.set(6, 5, 7)
        // this.istance.position.set(2, 4, 7)
        // this.istance.position.set(0, 0, 7)
        // this.istance.position.set(-7, 0, -2)
        if (this.isMobileDevice()) {
            console.log('MOBILE');
            this.istance.position.x = -9
        } else {
            console.log('DESKTOP');
            this.istance.position.x = -7
        }
        console.log(this.istance.position.x);
        this.istance.position.y = 0
        this.istance.position.z = -2
        this.initialPosition = this.istance.position.clone()
        this.initialRotation = this.istance.rotation.clone()
        // this.istance.castShadow = true
        this.scene.add(this.istance)

        this.axes = new THREE.AxesHelper(6)
        this.axes.visible = false

        this.scene.add(this.axes)

        // console.log(this.istance);
        // console.log('Axes', this.axes);
    }

    setOrbitControls() {
        this.controls = new OrbitControls(this.istance, this.canvas)
        this.controls.enableDamping = true
        this.controls.minDistance = 3
        if (this.isMobileDevice()) {
            this.controls.maxDistance = 15

        } else {
            this.controls.maxDistance = 10

        }
        this.controls.enablePan = false
        this.controls.saveState()

    }

    resetRotation(camera, controls) {

        const RESET_DURATION = 1
        let startPosition = camera.position.clone();
        let endPosition = this.initialPosition;
        let startRotation = camera.rotation.clone()
        let endRotation = this.initialRotation
        gsap.to(startPosition, { x: endPosition.x, y: endPosition.y, z: endPosition.z, duration: RESET_DURATION, ease: Power3.easeOut, onUpdate: updateCamera, onUpdateParams: [camera] });

        gsap.to(startRotation, { x: endRotation.x, y: endRotation.y, z: endRotation.z, duration: RESET_DURATION, ease: Power3.easeOut, onUpdate: updateCameraRotation, onUpdateParams: [camera] })

        function updateCamera(camera) {
            camera.position.set(startPosition.x, startPosition.y, startPosition.z);
            controls.update();
        }
        function updateCameraRotation(camera) {
            camera.rotation.set(startRotation.x, startRotation.y, startRotation.z)
            controls.update();
        }
        this.rotationCounter = 0;

    }

    cameraZoomInOut(camera, object, zoom, controls) {

        // console.log(this.controls);
        const ZOOM_DURATION = 1; // Durata dell'animazione in secondi
        // const ZOOM_DISTANCE = -2.5; // Distanza tra la camera e l'oggetto
        const ZOOM_DISTANCE = zoom; // Distanza tra la camera e l'oggetto

        let vector = new THREE.Vector3()
        vector.setFromMatrixPosition(object.matrixWorld)
        // camera.lookAt(vector);
        // camera.position.lerp(vector, 0.5)

        let direction = camera.position.clone().sub(vector).normalize();
        let targetPos = new THREE.Vector3(vector.x - direction.x * (ZOOM_DISTANCE), vector.y - direction.y * (ZOOM_DISTANCE), vector.z - direction.z * (ZOOM_DISTANCE));
        let tween = gsap.to(camera.position, { x: targetPos.x, y: targetPos.y, z: targetPos.z, duration: ZOOM_DURATION, ease: Power3.easeOut, onUpdate: lookAtObject, onUpdateParams: [camera, vector], onComplete: stopAnimation });
        function lookAtObject(camera, vector) {
            camera.lookAt(vector);
            controls.update();
        }
        function stopAnimation() {
            tween.kill();
        }
    }

    rotateCameraRight(camera, object, controls) {

        // const ROTATE_DURATION = 1; // Durata dell'animazione in secondi
        // const ROTATE_ANGLE = 90; // Angolo di rotazione in gradi

        // let vector = new THREE.Vector3();
        // vector.setFromMatrixPosition(object.matrixWorld);
        // let distance = camera.position.distanceTo(vector);

        // let endRotation = { y: this.rotationCounter + (ROTATE_ANGLE * Math.PI / 180) };
        // gsap.to(camera.position, {
        //     x: vector.x + distance * Math.sin(endRotation.y),
        //     z: vector.z + distance * Math.cos(endRotation.y),
        //     duration: ROTATE_DURATION,
        //     ease: Power3.easeOut,
        //     onUpdate: updateCamera,
        //     onUpdateParams: [camera, vector],
        // });
        // this.rotationCounter += ROTATE_ANGLE * Math.PI / 180;
        // function updateCamera(camera, vector) {
        //     camera.lookAt(vector);
        // }

        var rotationAngle = Math.PI / 2;
        var relativeCameraPos = camera.position.clone().sub(object.position);
        var finalPosition = relativeCameraPos.applyAxisAngle(new THREE.Vector3(0, 1, 0), rotationAngle).add(object.position)
        gsap.to(camera.position, {
            duration: 1,
            x: finalPosition.x,
            y: finalPosition.y,
            z: finalPosition.z,
            onUpdate: function () {
                controls.update();
            }
        })
        // relativeCameraPos.applyAxisAngle(new THREE.Vector3(0, 1, 0), rotationAngle); //rotazione di un quarto di giro
        // camera.position.copy(relativeCameraPos.add(object.position));
        // this.controls.update();



    }


    setGui() {
        this.debugFolder.add(this.axes, 'visible').name('Axes Helper')
        this.debugFolder.add(this.istance.position, 'x').name('Camera position X').min(-10).max(9).step(0.01)
        this.debugFolder.add(this.istance.position, 'y').name('Camera position Y').min(-10).max(9).step(0.01)
        this.debugFolder.add(this.istance.position, 'z').name('Camera position Z').min(-10).max(9).step(0.01)
    }

    isMobileDevice() {
        return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
    };

    resize() {
        this.istance.aspect = this.sizes.width / this.sizes.height
        this.istance.updateProjectionMatrix()
    }

    update() {
        this.controls.update()
    }
}